module.exports = __webpack_public_path__ + "img/electric-car-gfc3525984_640.82623445.jpg";